import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.css']
})
export class RegisterPageComponent implements OnInit {
  isLoading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    // Removiendo la clase de invalido si existira
    document.getElementById("Email").classList.remove('is-invalid');
    document.getElementById("Password").classList.remove('is-invalid');
    document.getElementById("Password2").classList.remove('is-invalid');
    document.getElementById("Nombre").classList.remove('is-invalid');
    document.getElementById("Pais").classList.remove('is-invalid');

    // Poner todo como valido antes de verificar
    document.getElementById("Email").classList.add('is-valid');
    document.getElementById("Password").classList.add('is-valid');
    document.getElementById("Password2").classList.add('is-valid');
    document.getElementById("Nombre").classList.add('is-valid');
    document.getElementById("Pais").classList.add('is-valid');

    // Variable de control de errores
    var error = false;
    // Verificando que exista texto en estos campos
    if ((<HTMLInputElement>document.getElementById("Email")).value.length < 6) {
      document.getElementById("Email").classList.add('is-invalid')
      error = true;
    }
    if ((<HTMLInputElement>document.getElementById("Password")).value.length < 6) {
      document.getElementById("Password").classList.add('is-invalid')
      error = true;
    }
    if ((<HTMLInputElement>document.getElementById("Nombre")).value.length < 6) {
      document.getElementById("Nombre").classList.add('is-invalid')
      error = true;
    }
    if ((<HTMLInputElement>document.getElementById("Password2")).value.length < 6) {
      document.getElementById("Password2").classList.add('is-invalid')
      error = true;
    }
    if ((<HTMLInputElement>document.getElementById("Pais")).value == "Seleccione su pais") {
      document.getElementById("Pais").classList.add('is-invalid')
      error = true;
    }

    // Verificar si las claves son iguales en los campos correspondientes
    if ((<HTMLInputElement>document.getElementById("Password")).value != (<HTMLInputElement>document.getElementById("Password2")).value) {
      document.getElementById("Password2").classList.add('is-invalid')
      error = true;
      // Enviar el Alerta
      this.toastr.error('¡Las contraseñas no coinciden!');
    }

    if (!error) {
      this.isLoading = true;
      // Creando el Objeto Usuario
      const user = {
        email: (<HTMLInputElement>document.getElementById("Email")).value,
        password: (<HTMLInputElement>document.getElementById("Password")).value,
      };
      // Usando el Servicio de Autentificación (AuthService) con el Metodo "signUpWithCredentials"s
      this.authService
        .signUpWithCredentials(user)
        .then(() => {
          // Enviar el Alerta
          this.toastr.success('Usted se ha registrado con exito!');
          // Redireccionar
          setTimeout(() => {
            this.isLoading = false;
            this.router.navigate(['menu']);
          }, 3000);
        })
        .catch((err) => {
          console.log('error!', err);
          setTimeout(() => {
            // Enviar el Alerta
            this.toastr.error(err.message);
            this.isLoading = false;
          }, 3000);
        });
    }
  }

  authWithGoogle(): void {
    this.authService
      .loginWithGoogle()
      .then(() => {
        if (this.authService.isAuthenticated()) {
          this.router.navigate(['menu']);
        }
      })
      .catch((err) => console.log(err));
  }

  Register: AnimationOptions = {
    path: '/assets/img/register.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}
